import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import * as Highcharts from "highcharts";
import { AnalyticsWidgetService } from "src/app/services/analytics-widget/analytics-widget.service";
import { BpcChartType, FilterType, WidgetFilter } from "@core/models/analytics-dashboard-enums";
import { Subscription, takeUntil } from "rxjs"; // Import Subscription
import { lastn } from "@core/models/analytics-dashboard-constants";
import { firmPod } from "@core/static/tabs";
import { FIRMWIDE_ELEVATION_DONUT_CHART_OPTIONS, MOST_ACTIVE_EMPLOYEES_CHART_OPTIONS } from "@core/models/analytics-dashboard-highcharts";
import { ElevationReportService } from "src/app/services/elevation-report/elevation-report.service";
import { ElevationStatusCounts } from "src/app/components/elevation-report/elevation-report.component";
import { DeviceDetectorService } from "ngx-device-detector";
import { RouterService } from "src/app/services/router/router.service";

@Component({
  selector: "bpc-firmwide-donut-chart-widget",
  templateUrl: "./firmwide-donut-chart-widget.component.html",
  styleUrls: ["./firmwide-donut-chart-widget.component.scss"],
})
export class FirmwideDonutChartWidgetComponent {
  // Implement OnDestroy
  @Input() title!: string;
  @Input() loaders!: number | undefined;
  @Input() chartType!: BpcChartType | undefined;

  @Output() showGrid = new EventEmitter<{companyIds: number[]}>();
  @Output() hideGrid = new EventEmitter<{}>();

  filters: WidgetFilter[] = [];

  selectedFilters: any = [];

  loading = true;

  ChartTypes = BpcChartType;
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = "chart";
  chartOptions:Highcharts.Options = {};

  data: any;

  private refreshSubscription!: Subscription;

  get series(): any {
    return Array.isArray(this.chartOptions?.series) ? this.chartOptions.series[0] : [];
  }

  get isTablet(): boolean{
    return this.deviceDetectorService.isTablet();
  }

  constructor(
    private analyticsWidgetService: AnalyticsWidgetService,
    private elevationReportService: ElevationReportService,
    private cdRef: ChangeDetectorRef,
    private deviceDetectorService: DeviceDetectorService,
    private routerService: RouterService,
  ) {
    this.selectedFilters = {
      //last_n: lastn[1],
    };

    this.refreshSubscription = this.analyticsWidgetService.refreshData.subscribe((companyIds)=>{
      if (this.selectedSlice?.companyIds){
        this.selectedSlice = null;
      }
    });
  }

  ngOnInit() {
  this.analyticsWidgetService.getPods()
    .pipe(takeUntil(this.routerService.destroy$))
    .subscribe((pods) => {
      this.filters = [
        //{ filterType: FilterType.last_n, options: lastn, default: lastn[1] },
      ];
      this.getData();
    });
  }

  selectedSlice!: any;
  ngAfterViewChecked(): void {
    this.pieChartClicked();
  }

  pieChartClicked() {
    const data = this.series?.data;

    if (data != null && Array.isArray(data) && data.length > 0) {
      let elementSelected = false;

      data.forEach((element: any) => {
        if (element?.selected && element?.name) {
          if (this.selectedSlice?.name !== element.name) {
            this.selectedSlice = element;
            this.analyticsWidgetService.breakInCompanyIds = [];
            this.showGrid.emit({ companyIds: this.selectedSlice.companyIds });          }

          elementSelected = true;
        }
      });

      // ✅ Only emit hideGrid if something was selected before and now nothing is
      if (!elementSelected && this.selectedSlice) {
        this.selectedSlice = null;
        this.hideGrid.emit();
      }
    }
  }

  getData() {
    this.loading = true;

      this.elevationReportService
      .getFirmwideElevationOutcomes()
      .pipe(takeUntil(this.routerService.destroy$))
      .subscribe(response => {
        if (response.data) {
          this.data = response.data.totalElevatedCompanies;
          this.chartOptions = this.getDonutChartOptions(response.data.segmentCounts, response.data.totalElevatedCompanies);
          this.loading = false;
        }
      });
  }

  getDonutChartOptions(statusCounts: ElevationStatusCounts, totalCount: number): Highcharts.Options {
    const data = Object.entries(statusCounts)
      .filter(([_, value]) => value.count > 0) // Only include non-zero counts
      .map(([statusCode, value]) => ({
        name: statusCode,
        y: Math.round((value.count / totalCount) * 100),
        companyIds: value.companyIds
      }));
  
    return FIRMWIDE_ELEVATION_DONUT_CHART_OPTIONS(data, this.deviceDetectorService.isTablet());
  }
  onFilterChange(selectedFilters: any) {
    this.selectedFilters = selectedFilters;
    this.getData();
  }

  ngOnDestroy() {
    this.refreshSubscription?.unsubscribe();
  }
}
